<p>a2v-losses works!</p>
